"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var tokens_1 = require("../../tokens");
var Link = function (props) { return (React.createElement(Link.Element, __assign({}, automation_attribute_1.default('link'), props), props.children)); };
Link.Element = styled_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  text-decoration: none;\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  text-decoration: none;\n  &:hover {\n    color: ", ";\n  }\n"])), tokens_1.colors.link.default, tokens_1.colors.link.defaultHover);
var StyledLink = Link.Element;
exports.StyledLink = StyledLink;
Link.defaultProps = {
    target: '_self'
};
exports.default = Link;
var templateObject_1;
//# sourceMappingURL=link.js.map